import { get_NULL2w9d0rq01h4d4 as get_NULL } from './internal/NullSurrogate.mjs';
import { checkOwnershipoyid8o0pxxr7 as checkOwnership } from './internal/FlowExceptions.common.mjs';
import { ensureActive2yo7199srjlgl as ensureActive } from '../Job.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AbortFlowException2zdgh4w7z3hep as AbortFlowException } from './internal/FlowExceptions.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *first(_this__u8e3s4, $completion) {
  var result = {_v: get_NULL()};
  // Inline function 'kotlinx.coroutines.flow.collectWhile' call
  var collector = new (first$$inlined$collectWhile$1())(result);
  try {
    yield* _this__u8e3s4.collect_aksokr_k$(collector, $completion);
  } catch ($p) {
    if ($p instanceof AbortFlowException()) {
      var e = $p;
      checkOwnership(e, collector);
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$1 = $completion.get_context_h02k06_k$();
      ensureActive(tmp$ret$1);
    } else {
      throw $p;
    }
  }
  if (result._v === get_NULL())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Expected at least one element');
  return result._v;
}
var first$$inlined$collectWhile$1Class;
function first$$inlined$collectWhile$1() {
  if (first$$inlined$collectWhile$1Class === VOID) {
    class $ {
      constructor($result) {
        this.$result_1 = $result;
      }
      *emit_53hnst_k$(value, $completion) {
        this.$result_1._v = value;
        if (!false) {
          throw AbortFlowException().new_kotlinx_coroutines_flow_internal_AbortFlowException_hca45b_k$(this);
        }
        return Unit_instance;
      }
      emit_t92u1f_k$(value, $completion) {
        return this.emit_53hnst_k$(value, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [FlowCollector()], [1]);
    first$$inlined$collectWhile$1Class = $;
  }
  return first$$inlined$collectWhile$1Class;
}
//region block: exports
export {
  first as first22rf410wdc2iv,
};
//endregion

//# sourceMappingURL=Reduce.mjs.map
